import React from "react";
import { useTranslation } from "react-i18next";

import { LabelSearchBox } from "./LabelSearchBox";
import { PAGE_NUMBER_OPTIONS } from "../../../../config";
import ToggleBtns from "../../../ToggleBtns";
import { AdminLocationAlertsQueryParams } from "../types";

export interface IAdminLocationAlertsListControlsProps {
  value: AdminLocationAlertsQueryParams;
  onChange: (value: AdminLocationAlertsQueryParams) => void;
}

export const AdminLocationAlertsListControls = ({
  value,
  onChange,
}: {
  value: AdminLocationAlertsQueryParams;
  onChange: (value: AdminLocationAlertsQueryParams) => void;
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`adminLocationAlertsPage.adminLocationAlertsList.controls.${key}`);

  const handleLabelNameChange = (internal_label_name: string) => {
    onChange({
      ...value,
      internal_label_name,
    });
  };

  const handleNumberPerPageChange = (limit: number) => {
    onChange({
      ...value,
      limit: limit,
      offset: 0,
    });
  };

  return (
    <div className="list-top-bar flex-grid">
      <div className="left-side">
        <LabelSearchBox
          value={value.internal_label_name}
          onChange={handleLabelNameChange}
        />
      </div>
      <div className="right-side">
        <div className="per-page-toggle">
          <div className="number-of-logs-per-page-txt">
            {t("number_of_logs_per_page")}
          </div>
          <ToggleBtns
            selectedValue={value.limit || PAGE_NUMBER_OPTIONS[0]}
            options={PAGE_NUMBER_OPTIONS}
            onClickBtn={handleNumberPerPageChange}
          />
        </div>
      </div>
    </div>
  );
};
